function initTrustpilotReviews() {
    const sliderWrapper = document.querySelectorAll('.trustpilot-reviews__wrapper');
    sliderWrapper.forEach(wrapper => {
        if (!wrapper) return;

        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#trustpilot-reviews-' + id);
        const imageContainer = wrapper.querySelector('#trustpilot-image-' + id);
        const nextElement = wrapper.querySelector('.swiper-button-next');
        const prevElement = wrapper.querySelector('.swiper-button-prev');
        const scrollBar = wrapper.querySelector('.swiper-scrollbar');
        const pagination = wrapper.querySelector('.swiper-pagination');

        if (!container) return;

        if (container.swiper) {
            container.swiper.destroy();
        }

        let swiper = new Swiper(container, {
            slidesPerView: 1.2,
            spaceBetween: 16,
            navigation: {
                nextEl: nextElement,
                prevEl: prevElement,
            },
            scrollbar: {
                el: scrollBar,
                hide: true,
            },
            breakpoints: {
                700: { slidesPerView: 2.5 },
                1000: { slidesPerView: 3.5 },
                1200: { slidesPerView: 5.5 },
            },
        });

        if (!imageContainer) return;

        if (imageContainer.swiper) {
            imageContainer.swiper.destroy();
        }

        let imageSwiper = new Swiper(imageContainer, {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                700: { slidesPerView: 4.1 },
                1000: { slidesPerView: 6.1 },
                1200: { slidesPerView: 8.1 },
                1600: { slidesPerView: 10.1 },
            },
        });
    });
}
document.addEventListener("DOMContentLoaded", function () {
    initTrustpilotReviews();
});